import React, {useState,useEffect} from 'react';
import { useParams } from 'react-router-dom';
import {API_URl} from './context';
import "./App.css";
// import {setIsError} from "./context";

const SingleMovie = () => {
  const {id} = useParams();

  const [isLoading, setIsLoading,] = useState(true);
  const [movie,setMovie] = useState("");

  const getMovies = async (url)=>{
      setIsLoading(true);
      try{
            const res = await fetch(url);
            const data = await res.json();
            console.log(data);
            if(data.Response === "True")
            {
                setIsLoading(false);
                // setIsError({
                //     show: false,
                //     msg: ""
                // });
                setMovie(data);
            }
        } catch(error){
            console.log(error);
        }
    };

    useEffect(() => {
        let timerOut = setTimeout(()=>{
            getMovies(`${API_URl}&i={id}`);
        },800);

        return ()=> clearTimeout(timerOut);
    }, [id]);

    // if(isLoading){
    //     return (
    //         <div className="movie-section">
    //             <div className="loading">Loading...</div>
    //         </div>
    //     );
    // }

    

  return (
      <>
            <div className='single-movie-page'>This is a movie</div>
      </>
  )
}

export default SingleMovie

//Work Left before watching hosting video : Make single movie page more attractive using css
//Rest is fine as of now
//Don't mess up between yours and thapa's code